import React from "react";
import "./spinner.css";

export default function LoadingSpinnerSmall() {
  return (
    <div className="spinner-container-small">
      <div className="loading-spinner-small"></div>
    </div>
  );
}